
import { DayPicker } from 'react-day-picker';
import moment from 'moment';
import Cleave from 'cleave.js/dist/cleave-react';
import React from 'react';
import { connect } from 'react-redux';
import { FormControl, Button } from 'react-bootstrap';
import Loading from '../../components/shared/Loading';
import BinderRevisions from './BinderRevisions';
import { lockBind } from '../actions';
import { formatDate, parseDate } from '../../utils/utilities.js';
import FileInput from './FileInput';
import RadioContainer from '../../components/shared/FormBuilder/controls/RadioContainer';
import { validatePreviousDate } from '../../utils/checkBindDate.js';
import classNames from 'classnames';
import { getCurrentSession } from '../../../lib/authentication';
import { CalendarDays } from 'lucide-react';

class BinderDialogBox extends React.Component {
    constructor(props) {
        super(props)
        var setExpDate = new Date();
            setExpDate.setDate(setExpDate.getDate() + 1);
        const miscellaneousDocsLabel = (<span>Miscellaneous<br />Documents :</span>);
        this.state = {
            arrFile: [],
            value: props.getSaved ? props.submission.binderData.brokerComments : '',
            isLoading: false, isSaveLoading: false,
            effDate: props.getSaved ? new Date(props.submission.binderData.bindeffectiveDate) : '',
            expDate: props.getSaved ? new Date(props.submission.binderData.bindexpirationDate) : '',
            initiatedDate: props.getSaved ? new Date(props.submission.binderData.bindInitiated) : new Date(),
            savedRevision: props.getSaved ? props.submission.binderData.bindedRevision : null,
            month: undefined,
            selectedRevision: {},
            validSelectedRevision: props.getSaved ? true : false,
            validEffDate: false,
            validExpDate: false,
            acceptTRIA: props.getSaved ? props.submission.binderData.bindAcceptTRIA : '',
            attachments: [
                {
                  id: 'signedApplication',
                  label: '*Signed Application :',
                  name: 'SignedApplication',
                  fileName: '',
                  fileArray: [],
                  suffix: 'SA',
                  attached: false,
                  fileSize: 0,
                  required: true,
                  valid: false,
                },
                {
                  id: 'stability',
                  label: 'Letter of Structural Stability :',
                  name: 'Structural Stability',
                  fileName: '',
                  suffix: 'SS',
                  attached: false,
                  fileSize: 0,
                  fileArray: [],
                  required: false,
                  valid: false,
                },
                {
                  id: 'miscellaneousDocs',
                  label: miscellaneousDocsLabel,
                  name: 'Miscellaneous Documents',
                  fileName: '',
                  suffix: 'MD',
                  attached: false,
                  fileSize: 0,
                  fileArray: [],
                  required: false,
                  valid: false,
                }
              ]
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleEffDate = this.handleEffDate.bind(this);
        this.handleExpDate = this.handleExpDate.bind(this);
        this.handleRevisionSelect = this.handleRevisionSelect.bind(this);
        this.YearMonthForm = this.YearMonthForm.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleAcceptTRIA = this.handleAcceptTRIA.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleExpDateChange = this.handleExpDateChange.bind(this);
        this.handleOpenCalendar = this.handleOpenCalendar.bind(this);
        this.handleOpenCalendarExp = this.handleOpenCalendarExp.bind(this);
    }

    componentDidMount() {
        const {attachments} = this.state;
        const params = {
          id: this.props.submission.id,
          revisionNumber: 1,
        }
        getCurrentSession().then(result => {
            const { accessToken } = result;
            return apigClient.bindReportsGet(
                params, {},
                {
                    headers: {
                        Authorization: accessToken
                    }
                })
        }).then(response => {
          const availableFiles = response.data;
            availableFiles.forEach(file => {
            const fileName = file.key.split("/").pop();
            const fileNameWithoutExt = fileName.replace(".pdf", "");
            const suffix = fileNameWithoutExt.split("_").pop();
            const index = attachments.findIndex(attachment => attachment.suffix === suffix);
            if (index !== -1) {
                attachments[index].fileName = fileName
                attachments[index].fileSize = file.size;
                attachments[index].attached = true;
                attachments[index].valid = true;
                if (suffix === 'MD') {
                    attachments[index].fileArray.push({name: fileName, size: file.size});
                     }
            }

          });
          this.setState({attachments})

        }).catch(err => console.log(err));
      }


    handleDateChange(event) {
        if (event.target.value.length === 10) {
        this.setState({ effDate: event.target.value, validEffDate: true });
        } else {
            this.setState({ effDateHolder: event.target.value, effDate: '', validEffDate: false });
        }
    }

    handleExpDateChange(event) {
        if (event.target.value.length === 10) {
        this.setState({ expDate: event.target.value, validExpDate: true });
        } else {
            this.setState({ expDateHolder: event.target.value, expDate: '', validExpDate: false });
        }
    }

    handleOpenCalendar() {
        if (this.state.openC !== true) {
            this.setState({
                openC: true
            })
        } else {
            this.setState({
                openC: false
            })
        }
    }

    handleOpenCalendarExp() {
        if (this.state.openExpDate !== true) {
            this.setState({
                openExpDate: true
            })
        } else {
            this.setState({
                openExpDate: false
            })
        }
    }


    handleFileChange(attachment) {
        const { attachments } = this.state;
        const index = attachments.findIndex(at => at.id === attachment.id);
        if (index !==-1) {
            attachments[index].fileSize = attachment.fileSize;
            attachments[index].attached = attachment.attached;
            attachments[index].valid = attachment.valid;
            attachments[index].fileName = attachment.fileName;

            if (attachments[index] && Array.isArray(attachments[index].fileArray) && attachments[index].name ==="Miscellaneous Documents")
            {

                attachments[index].fileArray = attachment.fileArray;

            }

            this.setState({attachments});

        }
    }

    handleRevisionSelect(selectedRevision, nullSaved) {
        this.setState({
            selectedRevision,
            validSelectedRevision: selectedRevision.isSelected
        })
        if (nullSaved) {
            this.setState({
                savedRevision: null,
            })
        }
    }

    handleChange(evt) {
        this.setState({
            ...this.state,
            value: evt.target.value
        })
    }

    handleEffDate(day) {
        if (day) {
            this.setState({validEffDate: true});
            this.setState({ effDate: day, openC: false});
        }
     }

     handleExpDate(day) {
         if (day) {
            this.setState({validExpDate: true});
            this.setState({ expDate: day, openExpDate: false });
         }
     }

    handleClick() {
        this.setState({
            ...this.state,
            isLoading: true
        })
        const { value, effDate, expDate, selectedRevision, attachments, acceptTRIA } = this.state;
        const { submission, user, underwriter, isUnderwriter } = this.props;
        const submissionDetails = {
            effectiveDate: effDate,
            insuredName: submission.primaryInsuredName,
            id: submission.id,
            contactInfo: submission.contactInfo,
            brokerComments: value,
            brokerId: submission.brokerId,
            brokerFirstName: user.firstName,
            brokerLastName: user.lastName,
            underwriterName: underwriter.name,
            underwriterEmail: underwriter.email,
            underwriterPhone: underwriter.phone,
            selectedRevision,
            isUnderwriter,
            expirationDate: expDate,
            bindedBy: user.id,
            acceptTRIA,
        }
        const arrFile = [];
        for (const attachment of attachments) {
            if (attachment.attached && attachment.valid) {
                if (attachment.suffix !="MD")
                {
               arrFile.push(attachment.fileName);
                }
                else {
            if (Array.isArray(attachment.fileArray)) {
                for (const file of attachment.fileArray) {
                    if (file.name)
                    {
                    arrFile.push(file.name);
                    }
                }
            }
            }

            }
        }
        const ObjFiles = {
            arrFile,
            submission: submissionDetails,
        }
        getCurrentSession().then(result => {
            const { accessToken } = result;
            return apigClient.submissionsBindPost(
                {},
                ObjFiles,
                submissionDetails,
                {
                    headers: {
                        Authorization: accessToken
                    }
                })
        }).then(response => {
            if (response.status == 200) {
                this.props.handleUpload(response);
                this.setState({
                    ...this.state,
                    isLoading: false
                });
                (!response.data ||
                    !response.data.errorMessage)&&
                            this.props.lockBind(submission.id, true);
            }
            else console.error('Failed');
        })
    }

    handleSave() {
        this.setState({
            ...this.state,
            isSaveLoading: true,
        })
        const { value, effDate, expDate, selectedRevision, attachments, acceptTRIA } = this.state;
        const { submission, user, underwriter, isUnderwriter } = this.props;
        const submissionDetails = {
            effectiveDate: effDate,
            insuredName: submission.primaryInsuredName,
            id: submission.id,
            contactInfo: submission.contactInfo,
            brokerComments: value,
            brokerId: submission.brokerId,
            brokerFirstName: user.firstName,
            brokerLastName: user.lastName,
            underwriterName: underwriter.name,
            underwriterEmail: underwriter.email,
            bindInitiated: this.state.initiatedDate,
            selectedRevision,
            isUnderwriter,
            expirationDate: expDate,
            bindedBy: user.id,
            acceptTRIA,
            isBinderSaved: true,
            isNotified: this.props.getSaved,
        }
        const arrFile = [];
        for (const attachment of attachments) {
            if (attachment.attached && attachment.valid) {
                if (attachment.suffix !="MD")
                {
               arrFile.push(attachment.fileName);
                }
                else {

            if (Array.isArray(attachment.fileArray)) {
                for (const file of attachment.fileArray) {
                    if (file.name)
                    {
                    arrFile.push(file.name);
                    }
                }
            }
        }


            }
        }
        const ObjFiles = {
            arrFile,
            submission: submissionDetails,
        }
        getCurrentSession().then(result => {
            const { accessToken } = result;
            return apigClient.submissionsBindPost(
                {},
                ObjFiles,
                submissionDetails,
                {
                    headers: {
                        Authorization: accessToken
                    }
                })
        }).then(response => {
            if (response.status == 200) {
                this.props.handleSave(response.data);
                this.setState({
                    ...this.state,
                    isSaveLoading: false
                });
                (!response.data ||
        !response.data.errorMessage)&&
                this.props.lockBind(submission.id, false, true);

            }
            else console.error('Failed');
        })
    }

    validateBind(modifiedEffDate, modifiedExpDate) {
        const { effDate, expDate, validSelectedRevision, attachments, acceptTRIA, isSaveLoading } = this.state;
        let isRequiredFilesAttached = true;
        let isAttachedFileValid = true;
        let isFileWithinLimit = true;
        let totalFileSize = 0;
        attachments.forEach(attachment => {
            if (attachment.required && !attachment.attached) {
                isRequiredFilesAttached = false;
            }
            if (attachment.attached && !attachment.valid) {
                isAttachedFileValid = false;
            }
            if (attachment.attached) {
                if (attachment.suffix=="MD")
                {
                    attachment.fileArray.map(file => {
                        totalFileSize += file.size;

                    }
                        );
                }
                totalFileSize += attachment.fileSize;
            }
        });

        isFileWithinLimit = totalFileSize <= (20*1024*1024);

        return !!effDate && !!expDate && !!modifiedExpDate && !!modifiedEffDate && (modifiedExpDate>modifiedEffDate) && validSelectedRevision && isRequiredFilesAttached && isAttachedFileValid && isFileWithinLimit && (acceptTRIA !== '') && !isSaveLoading;
    }


    getDefaultDate(minDate) {
        const min = Date.parse(minDate);
        const dtc = Date.parse(this.state.effDate);

        return min > dtc ? minDate : this.state.effDate;
    }

    getDefaultExpDate(effDate, expDate) {
        const min = Date.parse(effDate);
        const dtc = Date.parse(expDate);

        return dtc > min ? expDate : effDate;
    }

     YearMonthForm({ date, localeUtils, onChange}) {
        const months = localeUtils.getMonths();
        const currentYear = new Date().getFullYear();
        const fromMonth = new Date(currentYear-1, 0);
        const toMonth = new Date(currentYear + 10, 12);
        const years = [];
        for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
          years.push(i);
        }

        const handleChange = function handleChange(e) {

          const { year, month } = e.target.form;
          onChange(new Date(year.value, month.value));
        };

        return (
          <form className="DayPicker-Caption">
            <select name="month" onChange={handleChange} value={date.getMonth()}>
              {months.map((month, i) => (
                <option key={month} value={i}>
                  {month}
                </option>
              ))}
            </select>
            <select name="year" onChange={handleChange} value={date.getFullYear()}>
              {years.map(year => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </form>
        );
      }

    handleAcceptTRIA(name) {
        const option = document.querySelector(`.${name} input:checked`);
        if (option) {
            this.setState({acceptTRIA: option.value.toString()});
        }
    }

    render() {
        const inputFormat = "text";
        const { effDate, expDate, isLoading, isSaveLoading, savedRevision, validSelectedRevision, attachments, initiatedDate } = this.state;
        const modifiedEffDate = new Date(effDate);
        const modifiedExpDate = new Date(expDate);
        const modifiedInitiatedDate = new Date(validatePreviousDate(initiatedDate));
        modifiedInitiatedDate.setDate(modifiedInitiatedDate.getDate()-1)
        const currentYear = new Date().getFullYear();

        const canAllowBackDate = !this.props.isUnderwriter ? (modifiedEffDate>=modifiedInitiatedDate) : true;
        const disableCheck = this.validateBind(modifiedEffDate, modifiedExpDate) && canAllowBackDate? false : true;
        let isAttachmentValid = false;
        const invalidAtttachment = attachments.find(attachment => attachment.attached && !attachment.valid);
        if (invalidAtttachment) {
            isAttachmentValid = false;
        } else {
            isAttachmentValid = true;
        }
        const disableExpDate = !!effDate ? new Date(effDate) : new Date();
        !!effDate ? disableExpDate.setDate(disableExpDate.getDate()):[];
        let totalFileSize = this.state.attachments.reduce((acc, cur) => acc+ cur.fileSize, 0);
        const attachment= this.state.attachments;
        var arr= attachment.filter(attachment => attachment.suffix=="MD");
        if (arr.length>0 && arr)
        {
        arr[0].fileArray.map(file => {
            totalFileSize += file.size;
        });
    }


        const isFileLimitExceeded = totalFileSize > (20*1024*1024);

        const fileInputs = this.state.attachments.map(attachment => (
            <FileInput
                key = {attachment.id}
                id = {attachment.id}
                label = {attachment.label}
                name = {attachment.name}
                suffix = {attachment.suffix}
                submissionID = {this.props.submission.id}
                fileName = {attachment.fileName}
                fileArray = {attachment.fileArray}
                fileSize = {attachment.fileSize}
                attached = {attachment.attached}
                isFileLimitExceeded = {isFileLimitExceeded}
                onFileChange = {this.handleFileChange}
                />
        ));

        const triaData = {
            "questionId": "88",
            "text": "",
            "name": "acceptTRIA",
            "inputFormat": "radio",
            "inputType": "radio",
            "required": false,
            "attributes": {
               "options": [
                  {
                     "optionId": "1",
                     "text": "Accept",
                     "value": true
                  },
                  {
                     "optionId": "2",
                     "text": "Reject",
                     "value": false
                  }
               ]
            }
         };

        return (
            <div className="binderModelBox">
                <div className="row">
                    <div className="col-xs-12 mt_10">
                        <h3 className="quoteTitle">Bind Checklist</h3>
                    </div>
                </div>
                <div className="row spacing">
                    <div className="col-xs-12">Please ensure that your quote is up-to-date, and all subjectivities are signed and dated.
                    <br />
                        <div className="row">
                            <div
className="col-xs-12 textforbinderbox"
                                style={{ color: isAttachmentValid ? '' : 'red' }}>
                                Attachments must be uploaded in PDF Format only.
                            </div>
                        </div>
                    </div>
                </div>
                <h5 className={'rivisionTitle'}>Which quote revision are you requesting for bind?</h5>
                <BinderRevisions handlepdf={this.props.handlepdf} id={this.props.submission.id} showModal={this.props.showModal} savedRevision = {savedRevision} onSelect={this.handleRevisionSelect} />
                <div className="row getdown mt_20">
                    <div className="col-xs-4 bind-documents">*Effective Date :</div>
                <div className="modalDatePicker col-xs-8">
                <div className="row" style={{marginLeft: '0px'}}>
                <Cleave
                id={'effDate'}
                className={classNames(
                    'form-control',
                    'number-control',
                    'input-numeral',
                    'col-xs-8',
                    { filled: this.state.effDate ? moment(this.state.effDate).format('MM/DD/YYYY') : this.state.effDateHolder },
                )}
                style={{width: '30%'}}
                autoComplete={false}
                value={this.state.effDate ? moment(this.state.effDate).format('MM/DD/YYYY') : this.state.effDateHolder}
                placeholder="mm/dd/yyyy"
                options={{
                    date: true,
                    datePattern: ['m', 'd', 'Y']
                }}
                onChange={this.handleDateChange}
            /><button className="calendarButton" onClick={this.handleOpenCalendar}>
                <CalendarDays size={16} color="#42b6e2"/>
              </button>
               {this.state.openC && <DayPicker
                classNames={{
                    root: "DayPicker",
                    day: "DayPicker-Day",
                    selected: "DayPicker-Day--selected",
                    disabled: "DayPicker-Day--disabled",
                }}
                captionLayout="dropdown"
                formatDate={formatDate}
                parseDate={parseDate}
                defaultMonth={modifiedEffDate instanceof Date && !Number.isNaN(modifiedEffDate.getTime())
                    ? modifiedEffDate : ''}
                startMonth={new Date(currentYear - 1, 0)}
                endMonth={new Date(currentYear + 10, 12)}
                selected={this.state.effDate}
                onSelect={(inDate) => {
                    this.setState({
                        effDate: inDate
                    })
                }}
                placeholder={'mm/dd/yyyy'}
                onDayClick={this.handleEffDate}
                mode="single"
                disabledDays={(this.props.isUnderwriter ? {} : [{from: new Date(currentYear-1, 0), to: modifiedInitiatedDate}])}
               />}

                </div>
               {!this.props.isUnderwriter && (modifiedInitiatedDate>modifiedEffDate) && this.state.validEffDate && <div style={{ fontSize: '10px', color: 'red', lineHeight: 2.0}}>{`To Bind in Owner's Edge portal, the effective date must not be more than 1 day prior to today's date`}</div>}
                </div>
                </div>
                <div className="row getdown mt_10">
                    <div className="col-xs-4 bind-documents">*Expiration Date :
                    </div>
                <div className="modalDatePicker col-xs-8">
                <div className="row" style={{marginLeft: '0px'}}>
                <Cleave
                id={'expDate'}
                className={classNames(
                    'form-control',
                    'number-control',
                    'input-numeral',
                    'col-xs-8',
                    { filled: this.state.expDate ? moment(this.state.expDate).format('MM/DD/YYYY') : this.state.expDateHolder },
                )}
                style={{width: '30%'}}
                autoComplete={false}
                value={this.state.expDate ? moment(this.state.expDate).format('MM/DD/YYYY') : this.state.expDateHolder}
                placeholder="mm/dd/yyyy"
                options={{
                    date: true,
                    datePattern: ['m', 'd', 'Y']
                }}
                onChange={this.handleExpDateChange}
            /><button className="calendarButton" onClick={this.handleOpenCalendarExp}>
                <CalendarDays size={16} color="#42b6e2"/>
            </button>
                   {this.state.openExpDate && <DayPicker
                    classNames={{
                        root: "DayPicker",
                        day: "DayPicker-Day",
                        selected: "DayPicker-Day--selected",
                        disabled: "DayPicker-Day--disabled",
                    }}
                    captionLayout="dropdown"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    defaultMonth={modifiedExpDate instanceof Date && !Number.isNaN(modifiedExpDate.getTime())
                        ? modifiedExpDate : ''}
                    startMonth={new Date(currentYear - 1, 0)}
                    endMonth={new Date(currentYear + 10, 12)}
                    selected={this.state.expDate}
                    onSelect={(inDate) => {
                        this.setState({
                            expDate: inDate
                        })
                    }}
                    placeholder={'mm/dd/yyyy'}
                    onDayClick={this.handleExpDate}
                    mode="single"
                    disabledDays= {[{from: new Date(currentYear-1, 0), to: disableExpDate}]}
                    />}
                </div>
                {(modifiedExpDate<=modifiedEffDate) && this.state.validExpDate && <div style={{ fontSize: '10px', color: 'red', lineHeight: 2.0}}>{`Expiration date should be after the Effective date`}</div>}
                </div>
                </div>
                <div className="row getdown mt_20">
                    <div className="col-xs-4">*TRIA:</div>
                    <div className="col-xs-8 tria-radio">
                        <RadioContainer
                        data = {triaData}
                        initialParams = {{}}
                        initialValues = {{acceptTRIA: this.state.acceptTRIA}}
                        handleFormChange = {() => this.handleAcceptTRIA(triaData.name)}
                        handleSupplementTrigger = {() => {}}
                        />
                    </div>
                </div>
                {fileInputs}
                <div className="row generalcomments">
                    <div className="col-xs-12 mt"><h5>General Comments</h5></div>
                </div>
                <div className="row">
                    <div style={{ width: "100%"}} className="col-xs-10 mt_10">
                        <FormControl
                            autoComplete={false}
                            type={inputFormat}
                            onChange={this.handleChange}
                            componentClass={'textarea'}
                            value={this.state.value}
                            placeholder={'Optional'}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 textforbinderbox">Please provide any comments or assumptions for binding.</div>
                </div>
                <div className="row">
                    <div className="col-xs-12 mt">
                        <Button
                            type="submit"
                            id="upsellSubmitButton"
                            disabled={disableCheck}
                            className="mt"
                            onClick={this.handleClick}
                        >
                             {isLoading === true ? <Loading width="20px" height="20px" classes="spinner" /> : "Submit"}
                        </Button>
                        <Button
style={{float: "right"}}
                            type="submit"
                            id="upsellSubmitButton"
                            disabled={!(!!expDate && !!effDate && !!validSelectedRevision && (modifiedExpDate>modifiedEffDate) && canAllowBackDate && !isLoading)}
                            className="mt"
                            onClick={this.handleSave}
                        >
                            {isSaveLoading === true ? <Loading width="20px" height="20px" classes="spinner" /> : "Save for Later"}
                        </Button>
                        {isFileLimitExceeded &&
                        <div style={{ color: 'red', marginTop: '10px' }}>Total file size exceeded the maximum limit of 20MB.</div>
                    }
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(null, { lockBind })(BinderDialogBox)

